// import React, { useState,useEffect } from 'react';
// import ModalViewSelectedSales from './ModalViewSelectedSales';
// import translations from '../../../utils/language/translations.json';
// import { useTranslation } from 'react-i18next';
// import PaginationComponentGridSold from './PaginationComponentGridSold';
// import { useNavigate } from "react-router-dom";


// const GridSoldOrOffer = ({ transactions,setTransactions, userId, Status, liveCsrfToken,fetchSoldOrOffer }) => {
//   const { t: translate, i18n } = useTranslation();
//   const currentLang = i18n.language;
//   const navigate = useNavigate();
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [activeOffer, setActiveOffer] = useState(null);

//   const openOffer = (offer) => {
//     setActiveOffer(offer);
//     setIsModalOpen(true);
//   };
//   const closeOffer = () => {
//     setIsModalOpen(false);
//     setActiveOffer(null);
//     console.log('onclocse fiat123123??')
//   };
//   // const t = (key) => translations.GridSoldOrOffer[key][currentLang];
//   const t = (key) => {
//     if (!translations.GridSoldOrOffer || !translations.GridSoldOrOffer[key]) {
//       console.warn(`Missing translation key: ${key}`); // Log missing keys
//       return key; // Return the key as fallback instead of breaking the app
//     }
  
//     return translations.GridSoldOrOffer[key][currentLang] || key;
//   };
  
//   const [isMobile, setIsMobile] = useState(false);
  
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 768);
//     };
  
//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);
  
//   const [sortValue, setSortValue] = useState("dateReceivedDesc"); // Default sorting
  
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 5; // Change this value as needed

//   // Calculate total pages
//   const totalPages = Math.ceil(transactions.length / itemsPerPage);

//   // Get current page transactions
//   const paginatedTransactions = transactions.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);



//   // // Group transactions by TransactionId when component mounts or saleOffers change
//   useEffect(() => {
//     setCurrentPage(1)
//   }, [transactions]); // Runs when saleOffers updates

//   // Format date function
//   const formatDate = (dateString) => {
//     return new Date(dateString).toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'long',
//       day: 'numeric',
//     });
//   };

//   // Sorting function
//   const handleSort = (event) => {
//     const selectedSort = event.target.value;
//     setSortValue(selectedSort);

//     const sortedTransactions = [...transactions].sort((a, b) => {
//       switch (selectedSort) {
//         case "dateReceivedAsc":
//           return new Date(a[0].Date) - new Date(b[0].Date);
//         case "dateReceivedDesc":
//           return new Date(b[0].Date) - new Date(a[0].Date);
//         case "priceAsc":
//           return (
//             a.reduce((sum, item) => sum + item.Price, 0) -
//             b.reduce((sum, item) => sum + item.Price, 0)
//           );
//         case "priceDesc":
//           return (
//             b.reduce((sum, item) => sum + item.Price, 0) -
//             a.reduce((sum, item) => sum + item.Price, 0)
//           );
//         default:
//           return 0;
//       }
//     });

//     setTransactions(sortedTransactions); // Update state with sorted transactions
//   };
// const fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: 'CAD', maximumFractionDigits: 0 });
//   return (

//     <div className="grid-sold-offer">
//       <h3>{Status === ('Waiting' || 'Counter') ? t('Answer Now') : t(Status)}</h3>
//       <label>{t('Sort by')}: </label>
// <select value={sortValue} onChange={handleSort} className='custom-select-simple'>
//   <option value="dateReceivedDesc">{t("Date Received (Newest to Oldest)")}</option> {/* Default */}
//   <option value="dateReceivedAsc">{t("Date Received (Oldest to Newest)")}</option>
//   <option value="priceAsc">{t("Total Price (Low to High)")}</option>
//   <option value="priceDesc">{t("Total Price (High to Low)")}</option>
// </select>
    
// {(isMobile ? paginatedTransactions : paginatedTransactions).map((offer, idx) => {
//   const head = offer[0];
//   const isUserSeller = parseInt(head.SellerId) === parseInt(userId);
//   const sellerDisplayName = isUserSeller ? head.BuyerName : head.SellerName;
//   const sellerAvatar = (isUserSeller ?head.BuyerProfileImage:head.SellerProfileImage) || '/default-avatar.png';

//   const open = () => openOffer(offer);
//   const goSeller = (e) => {
//     e.stopPropagation();
//     navigate(
//       i18n.language === 'fr'
//         ? `/fr/ViewUserProfil/${head.SellerName}`
//         : `/ViewUserProfil/${head.SellerName}`
//     );
//   };

//   return (
//     <div key={head.TransactionId || idx} className="transaction-card tx-slim" onClick={open}>
//       {/* 1) Date (left) */}
//           <h4>{head?.Status}</h4>
//       <div className="transaction-details">
    
//         <p className="received-on" style={{marginLeft:'auto',marginRight:'auto'}}>
//          {formatDate(head.Date)}
//         </p>
//         <p style={{marginLeft:'auto',marginRight:'auto'}}>{t('Transaction')}#{head.TransactionId}</p>
//       </div>

//       {/* 2) Seller (compact) */}
//       <div className="seller-compact"  role="button" tabIndex={0}
//       // onClick={goSeller}
//            onKeyDown={(e)=>e.key==='Enter' && goSeller(e)}>
//         <img src={sellerAvatar} alt={sellerDisplayName} className="seller-avatar" />
//         <div className="seller-info">
//           {/* <span className="role seller-role">{t('Seller')}</span> */}
//           <div className="seller-name">{sellerDisplayName}</div>
//           <div className="seller-rating">
//             ({head.SellerTransactions || 0}) {(head.SellerRating * 20).toFixed(0)}%
//           </div>
//         </div>
//       </div>

//       {/* 3) Card (center) */}
//       <div className="card-preview">
//         <div className="image-container">
//           <img
//             src={head.ImageFront || head.Image || '/placeholder-image.png'}
//             alt="card"
//             className="card-img"
//           />
//           <div className="card-count">{offer.length}</div>
//         </div>
//       </div>
// <h2 style={{marginBottom:'0'}}>{t('For')}</h2>
//       {/* 4–5) For → Price & Shipping (right) */}
//     <span className="price-chip">{fmt.format(head.Price)}</span>
// <span className="shipping">+{fmt.format(head.Shipping)}<br/>{t('Shipping')}</span>
//     </div>
//   );
// })}



//        {totalPages > 1 && (
//         <PaginationComponentGridSold totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
//       )}

//             {/* Sidebar View Button */}
//       <div className="view-button-container">
//      {isModalOpen && activeOffer && (
    
//         <ModalViewSelectedSales 
//           offer={activeOffer}
//           Status={Status}
//           userId={userId}
//           liveCsrfToken={liveCsrfToken}
//            fetchSoldOrOffer={fetchSoldOrOffer}
//            show={isModalOpen}
//           onClose={closeOffer}
//         />)}
//       </div>

//     </div>
//   );
// };

// export default GridSoldOrOffer;
import React, { useEffect, useMemo, useState, useCallback } from "react";
import ModalViewSelectedSales from "./ModalViewSelectedSales";
import translations from "../../../utils/language/translations.json";
import { useTranslation } from "react-i18next";
import PaginationComponentGridSold from "./PaginationComponentGridSold";
import { useNavigate } from "react-router-dom";

/**
 * Props:
 * - transactions: Array<Array<TxRow>> (grouped by TransactionId)
 * - setTransactions: fn (kept for backwards-compat, not mutated here)
 * - userId: number
 * - Status: string (e.g., 'Waiting', 'Counter', 'WaitingPayment', etc.)
 * - liveCsrfToken: string
 * - fetchSoldOrOffer: fn to refresh list after modal actions
 * - initialOpenTxId?: number (optional) — auto-open this transaction when present
 */
const GridSoldOrOffer = ({
  transactions,
  setTransactions, // not mutated (kept to match parent signature)
  userId,
  Status,
  liveCsrfToken,
  fetchSoldOrOffer,
  initialOpenTxId,
}) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const navigate = useNavigate();

  // ---- i18n helper with safe fallback
  const t = useCallback(
    (key) => {
      const ns = translations?.GridSoldOrOffer || {};
      return ns[key]?.[currentLang] ?? key;
    },
    [currentLang]
  );

  // ---- mobile detection (matchMedia → less layout thrash)
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia("(max-width: 768px)").matches
      : false
  );
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener?.("change", handler);
    return () => mq.removeEventListener?.("change", handler);
  }, []);

  // ---- modal state
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeOffer, setActiveOffer] = useState(null);

  const openOffer = useCallback((offerGroup) => {
    setActiveOffer(offerGroup);
    setIsModalOpen(true);
  }, []);
  const closeOffer = useCallback(() => {
    setIsModalOpen(false);
    setActiveOffer(null);
  }, []);

  // ---- sorting + pagination (pure, do not mutate parent)
  const [sortValue, setSortValue] = useState("dateReceivedDesc");
  const itemsPerPage = 5;
  const [currentPage, setCurrentPage] = useState(1);

  const currencyFmt = useMemo(
    () =>
      new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: "CAD",
        maximumFractionDigits: 0,
      }),
    []
  );

  const formatDate = (dateString) =>
    new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

  // Guard for empty
  const safeTxs = Array.isArray(transactions) ? transactions : [];

  const sorted = useMemo(() => {
    const clone = [...safeTxs];
    const totalPrice = (group) => group.reduce((sum, it) => sum + (Number(it.Price) || 0), 0);

    switch (sortValue) {
      case "dateReceivedAsc":
        return clone.sort((a, b) => new Date(a[0]?.Date) - new Date(b[0]?.Date));
      case "dateReceivedDesc":
        return clone.sort((a, b) => new Date(b[0]?.Date) - new Date(a[0]?.Date));
      case "priceAsc":
        return clone.sort((a, b) => totalPrice(a) - totalPrice(b));
      case "priceDesc":
        return clone.sort((a, b) => totalPrice(b) - totalPrice(a));
      default:
        return clone;
    }
  }, [safeTxs, sortValue]);

  const totalPages = Math.ceil(sorted.length / itemsPerPage) || 1;
  const pageStart = (currentPage - 1) * itemsPerPage;
  const pageItems = sorted.slice(pageStart, pageStart + itemsPerPage);

  // Reset to page 1 whenever the underlying list changes
  useEffect(() => {
    setCurrentPage(1);
  }, [transactions?.length]);

  // ---- human title for the section
  const headerTitle = useMemo(() => {
    // Fix the invalid condition: ('Waiting' || 'Counter') === 'Waiting'
    if (Status === "Waiting" || Status === "Counter") return t("Answer Now");
    return t(Status);
  }, [Status, t]);

  // ---- navigation to seller/other party profile
  const goToProfile = useCallback(
    (showName) => {
      if (!showName) return;
      const url =
        i18n.language === "fr"
          ? `/fr/ViewUserProfil/${encodeURIComponent(showName)}`
          : `/ViewUserProfil/${encodeURIComponent(showName)}`;
      navigate(url);
    },
    [i18n.language, navigate]
  );

  // ---- allow notifications to open this view's modal via event
  useEffect(() => {
    const handler = (e) => {
      const txId = e?.detail?.transactionId;
      if (!txId) return;
      const match = sorted.find((g) => g?.[0]?.TransactionId === txId);
      if (match) openOffer(match);
    };
    window.addEventListener("open-marketplace-modal", handler);
    return () => window.removeEventListener("open-marketplace-modal", handler);
  }, [sorted, openOffer]);

  // ---- auto-open if initialOpenTxId provided
  useEffect(() => {
    if (!initialOpenTxId) return;
    const match = sorted.find((g) => parseInt(g?.[0]?.TransactionId) === parseInt(initialOpenTxId));

    console.log('match',match,'sorted',sorted,'initialOpenTxId',initialOpenTxId)
    if (match) openOffer(match);


  }, [initialOpenTxId, sorted, openOffer]);

  const handleSort = (e) => setSortValue(e.target.value);

  return (
    <div className="grid-sold-offer">
      <h3>{headerTitle}</h3>

      <label htmlFor="gridSoldSort">{t("Sort by")}:</label>{" "}
      <select
        id="gridSoldSort"
        value={sortValue}
        onChange={handleSort}
        className="custom-select-simple"
      >
        <option value="dateReceivedDesc">
          {t("Date Received (Newest to Oldest)")}
        </option>
        <option value="dateReceivedAsc">
          {t("Date Received (Oldest to Newest)")}
        </option>
        <option value="priceAsc">{t("Total Price (Low to High)")}</option>
        <option value="priceDesc">{t("Total Price (High to Low)")}</option>
      </select>

      {pageItems.map((offerGroup, idx) => {
        const head = offerGroup[0] || {};
        const isUserSeller =
          Number(head.SellerId) === Number(userId);

        const otherPartyName = isUserSeller ? head.BuyerName : head.SellerName;
        const otherPartyAvatar = (isUserSeller ? head.BuyerProfileImage : head.SellerProfileImage) || "/default-avatar.png";

        const onOpen = () => openOffer(offerGroup);
        const onProfileClick = (e) => {
          e.stopPropagation();
          goToProfile(otherPartyName);
        };

        return (
          <div
            key={head.TransactionId ?? `${idx}-tx`}
            className="transaction-card tx-slim"
            onClick={onOpen}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && onOpen()}
          >
            {/* Status & Dates */}
            <h4 style={{ marginBottom: 4 }}>{head?.Status}</h4>
            <div className="transaction-details">
              <p className="received-on" style={{ margin: "0 auto" }}>
                {formatDate(head.Date)}
              </p>
              <p style={{ margin: "0 auto" }}>
                {t("Transaction")}#{head.TransactionId}
              </p>
            </div>

            {/* Other party (compact) */}
            <div
              className="seller-compact"
              role="button"
              tabIndex={0}
              onClick={onProfileClick}
              onKeyDown={(e) => e.key === "Enter" && onProfileClick(e)}
            >
              <img
                src={otherPartyAvatar}
                alt={otherPartyName || "user"}
                className="seller-avatar"
              />
              <div className="seller-info">
                <div className="seller-name">{otherPartyName || t("User")}</div>
                {/* Display seller/buyer metrics based on role */}
                {isUserSeller ? (
                  <div className="seller-rating">
                    ({head.BuyerTransactions || 0}){" "}
                    {((Number(head.BuyerRating) || 0) * 20).toFixed(0)}%
                  </div>
                ) : (
                  <div className="seller-rating">
                    ({head.SellerTransactions || 0}){" "}
                    {((Number(head.SellerRating) || 0) * 20).toFixed(0)}%
                  </div>
                )}
              </div>
            </div>

            {/* Card preview */}
            <div className="card-preview">
              <div className="image-container">
                <img
                  src={head.ImageFront || head.Image || "/placeholder-image.png"}
                  alt="card"
                  className="card-img"
                />
                <div className="card-count">{offerGroup.length}</div>
              </div>
            </div>

            {/* Price block */}
            <h2 style={{ marginBottom: 0 }}>{t("For")}</h2>
            <span className="price-chip">{currencyFmt.format(Number(head.Price) || 0)}</span>
            <span className="shipping">
              +{currencyFmt.format(Number(head.Shipping) || 0)}
              <br />
              {t("Shipping")}
            </span>
          </div>
        );
      })}

      {totalPages > 1 && (
        <PaginationComponentGridSold
          totalPages={totalPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )}

      {/* Modal */}
      {isModalOpen && activeOffer && (
        <ModalViewSelectedSales
          offer={activeOffer}
          Status={Status}
          userId={userId}
          liveCsrfToken={liveCsrfToken}
          fetchSoldOrOffer={fetchSoldOrOffer}
          show={isModalOpen}
          onClose={closeOffer}
        />
      )}
    </div>
  );
};

export default GridSoldOrOffer;
